import React, { FC, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button, ButtonProps } from '@mantine/core';

import { FormContext } from './Form';

const FormSubmit: FC<
    ButtonProps & {
        onClick?: () => void;
        disableIfClean?: boolean;
        disableIfErrors?: boolean;
        submitOnce?: boolean;
    }
> = ({ children, onClick, loading, disableIfClean, disableIfErrors, submitOnce, ...buttonProps }) => {
    const { id, isSubmitted } = useContext(FormContext);

    const {
        formState: { isSubmitting, isDirty, errors },
    } = useFormContext();

    const hasErrors = Object.keys(errors).length > 0;
    const disabled = (disableIfClean && !isDirty) || (disableIfErrors && hasErrors);

    const successfullySubmittedOnce = submitOnce && isSubmitted && !hasErrors;

    return (
        <Button
            type="submit"
            onClick={(event) => {
                if (onClick) {
                    event.preventDefault();
                    onClick();
                }
            }}
            loading={loading || isSubmitting}
            data-cy="form-submit"
            disabled={disabled || isSubmitting || successfullySubmittedOnce}
            form={id}
            {...buttonProps}
        >
            {children}
        </Button>
    );
};

export { FormSubmit };
